import { render } from "./GlobalSearchResult.vue?vue&type=template&id=b1d2aa0e"
import script from "./GlobalSearchResult.vue?vue&type=script&lang=js"
export * from "./GlobalSearchResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__